export class SupplierOrderListModel {
    id: number;
    orderNo: number;
    supplier: string;
    date: Date;
    status: string;
    contract: string;
}



// WEBPACK FOOTER //
// ./src/app/suppliers-barcodes/models/supplier-order-list.model.ts